import instance, { ApiResponse } from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import { Dispatch, SetStateAction } from 'react';

const UNKOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class MyDocumentsApi extends BaseApi {
  public static createFile = async (data: FormData): Promise<any> => {
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.myDocuments.createFile,
        data,
        config
      );

      if (MyDocumentsApi.isResponseSuccessful(result.data)) {
        const data = result.data;
        return MyDocumentsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return null;
        } else {
          throw new Error();
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return { error: errors };
        }
      }
      return MyDocumentsApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  public static getFile = async (id: number): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.myDocuments.updateFile + `?id=${id}`
      );

      if (MyDocumentsApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return MyDocumentsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return null;
        } else {
          throw new Error();
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return null;
        }
      }
      return MyDocumentsApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  public static updateFile = async (data: FormData): Promise<any> => {
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.myDocuments.updateFile,
        data,
        config
      );

      if (MyDocumentsApi.isResponseSuccessful(result.data)) {
        const data = result.data;
        return MyDocumentsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return null;
        } else {
          throw new Error();
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return { error: errors };
        }
      }
      return MyDocumentsApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  public static viewFile = async (
    id: number,
    fileName: string,
    setDownloadFileMsgPopupOpen: Dispatch<SetStateAction<boolean>>,
    setDownloadDocDetails: Dispatch<SetStateAction<any>>
  ): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.myDocuments.viewFile + `?id=${id}`
      );

      if (MyDocumentsApi.isResponseSuccessful(result.data)) {
        if(result.data.details.bDownload){
          setDownloadFileMsgPopupOpen(true);
          setDownloadDocDetails({
            docURL: result.data.details.documentUrl,
            docExt: result.data.details.documentExtension,
            fileName: fileName,
          });
        } else {
          window.open(result.data.details.documentUrl, '_blank')?.focus();
        }
      } else {
        const errors = result.data.errors;
        if (errors) {
          return null;
        } else {
          throw new Error();
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return null;
        }
      }
      return MyDocumentsApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  public static deleteFile = async (ids: any): Promise<any> => {
    try {
      const payload = { idsToDelete: ids };

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.myDocuments.deleteFile,
        payload
      );

      if (MyDocumentsApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return MyDocumentsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return null;
        } else {
          throw new Error();
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return null;
        }
      }
      return MyDocumentsApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };

  public static createEditFolder = async (
    endpoint: string,
    data: any
  ): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoint,
        data
      );

      if (MyDocumentsApi.isResponseSuccessful(result.data)) {
        const data = result.data;
        return MyDocumentsApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return result.data;
        } else {
          throw new Error();
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return null;
        }
      }
      return MyDocumentsApi.errorResponse(UNKOWN_ERROR_MESSAGE);
    }
  };
}
